import React from 'react'
import he from 'he'
import Link from '../../utils/link'
import BoughtLogo from '../../assets/images/bought-white.svg'

const BoughtPropertyCard = ({url, imageSource, title, specs, price, testimonial, weblink}) => {
  return (
    <>
      { process.env.GATSBY_LOCATION === 'aus' &&
        <section className="property-card">
          <a href={weblink} className="property-card__inner" target='_blank' rel='nofollow noopener noreferrer'>
            <div className="property-card__top">
              <picture>
                <img src={imageSource} alt={title} key={title} />
              </picture>
              { !testimonial && process.env.GATSBY_LOCATION === 'aus' && <img className="sold bought_card-logo" src={BoughtLogo} alt="Bought"/> }
            </div>
            <div className="property-card__bottom">
              <h6>{ he.decode(title) }</h6>
              <ul>
                { specs.bed && <li>{ specs.bed } Beds</li> }
                { specs.bath && <li>{ specs.bath } Bath</li> }
                { specs.car && <li>{ specs.car } Car</li> }
              </ul>
              <div className="property-card__cost">{ price }</div>
            </div>
          </a>
        </section>
      }
      { process.env.GATSBY_LOCATION !== 'aus' &&
        <section className="property-card">
          <Link to={url} className="property-card__inner">
            <div className="property-card__top">
              <picture>
                <img src={imageSource} alt={title} key={title} />
              </picture>
            </div>
            <div className="property-card__bottom">
              <h6>{ he.decode(title) }</h6>
              { process.env.GATSBY_LOCATION !== 'nz' &&
                <ul>
                  { specs.bed && <li>{ specs.bed } Beds</li> }
                  { specs.bath && <li>{ specs.bath } Bath</li> }
                  { specs.car && <li>{ specs.car } Car</li> }
                </ul>
              }
              { process.env.GATSBY_LOCATION !== 'nz' && <div className="property-card__cost">{ price }</div> }
            </div>
          </Link>
        </section>
      }
    </>
  )
}

export default BoughtPropertyCard